import { $api } from "../AxiosInstance";

export class ProxyPackageService {
  /**
   * Get all proxy packages
   */
  static async getProxyPackages() {
    return await $api.get("/api/admin/proxy/package/all");
  }

  /**
   * Get proxy package by ID
   * @param {Number} id
   */
  static async getProxyPackageById(id) {
    return await $api.get("/api/admin/proxy/package", { params: { id } });
  }

  /**
   * Get proxy package by type
   * @param {Object} params
   * @param {String} params.proxyType - Type of proxy (IPv4, IPv6, ISP, Mobile)
   */
  static async getProxyPackageByType(params) {
    return await $api.get("/api/admin/proxy/package/proxyType", { params });
  }

  /**
   * Update proxy package
   * @param {Object} params
   * @param {Number} params.id
   * @param {String} params.name
   * @param {String} params.proxyType
   * @param {Number} params.count
   * @param {Number} params.price
   */
  static async updateProxyPackage(params) {
    return await $api.post("/api/admin/proxy/package/update", params);
  }
}
